export default "__VITE_ASSET__Comezk0Q__"